/* eslint-disable radix */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React from 'react';
import { useDispatch } from 'react-redux';
import { Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import {
  addMenuSubMenuID,
  addModuloSubMenuID,
} from '~/store/modules/SubMenu/actions';
import { handeGetMenusData } from '../../SubMenuServices';
import Lista from './Lista';
import { Container } from './styles';

function Card({
  modulos,
  moduloSelected,
  setModuloSelected,
  menus,
  loading,
  menuSelected,
  setMenuSelected,
  setMenus,
  setLoading,
}) {
  const dispatch = useDispatch();
  return (
    <Container>
      <Form style={{ width: '100%' }}>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label>Selecione o módulo para visualizar os menus</Label>
              <Input
                placeholder="Selecione..."
                type="select"
                onChange={(e) => {
                  dispatch(addModuloSubMenuID(parseInt(e.target.value)));
                  setModuloSelected(false);
                  setMenuSelected(false);
                  handeGetMenusData(
                    e,
                    setLoading,
                    setMenus,
                    setModuloSelected,
                    setMenuSelected
                  );
                }}
                defaultValue=""
                disabled={loading}
                required
              >
                <option value="" disabled>
                  Selecione...
                </option>
                {modulos.map((modulo) => (
                  <option key={modulo.id} value={modulo.id}>
                    {modulo.nome}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Selecione o menu</Label>
              <Input
                disabled={!moduloSelected || loading}
                placeholder="Selecione..."
                type="select"
                onChange={(e) => {
                  dispatch(addMenuSubMenuID(parseInt(e.target.value)));
                  setTimeout(() => {
                    setMenuSelected(false);
                    setLoading(true);
                    setMenuSelected(true);
                    setLoading(false);
                  }, 250);
                }}
                defaultValue=""
                required
              >
                <option value="">Selecione...</option>
                {menus.map((menu, index) => (
                  <option key={index} value={menu.id}>
                    {menu.nome}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
        </Row>
        {/*   {loading ? (
          <Row>
            <Col md={6}>
              <Button style={{ marginBottom: '12px' }} color="primary" disabled>
                <Spinner size="sm" color="light" />
              </Button>
            </Col>
            <Col md={6}>
              <Button style={{ marginBottom: '12px' }} color="primary" disabled>
                <Spinner size="sm" color="light" />
              </Button>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col md={6}>
              <Button
                style={{ marginBottom: '12px' }}
                color="primary"

                disabled={loading}
                size="sm"
              >
                <FaSearch /> Buscar
              </Button>
            </Col>
            <Col md={6}>
              <Button
                style={{ marginBottom: '12px' }}
                color="primary"
                disabled={!moduloSelected}
                onClick={() => {

                }}
                size="sm"
              >
                <FaSearch /> Buscar
              </Button>
            </Col>
          </Row>
        )} */}
      </Form>
      {menuSelected ? <Lista loading={loading} setLoading={setLoading} /> : ''}
    </Container>
  );
}

export default Card;
